import { IStrategy } from "@pulse-ui/codegen/generated_ts/org_entity";
import { IAGStrategyDataRow } from "../StrategyTable.types";

export const mapRowData = (strategiesResponse: IStrategy[] | null | undefined): IAGStrategyDataRow[] => {
    if (!strategiesResponse || !Array.isArray(strategiesResponse)) {
        return [];
    }

    const rows: IAGStrategyDataRow[] = [];

    for (const strategy of strategiesResponse) {
        rows.push({
            id: strategy.strategy_id,
            strategy_id: strategy.strategy_id,
            display_name: strategy.display_name || '-',
            is_active: strategy.is_active,
            created: strategy.created || '-',
        });
    }

    return rows;
};